import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { itemsApi, kategorienApi } from '../api';

export default function MasterListePage() {
  const [items, setItems] = useState([]);
  const [kategorien, setKategorien] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showKatForm, setShowKatForm] = useState(false);
  const [form, setForm] = useState({ name: '', kategorie_id: '', notiz: '', menge: '', einheit: '' });
  const [katForm, setKatForm] = useState({ name: '', icon: '📦' });
  const [editItem, setEditItem] = useState(null);
  const [filterKat, setFilterKat] = useState('alle');
  const navigate = useNavigate();

  const load = async () => {
    const [itemsRes, katRes] = await Promise.all([itemsApi.list(), kategorienApi.list()]);
    setItems(itemsRes.data);
    setKategorien(katRes.data);
  };
  useEffect(() => { load(); }, []);

  const handleAddItem = async (e) => {
    e.preventDefault();
    if (editItem) {
      await itemsApi.update(editItem.id, form);
      setEditItem(null);
    } else {
      await itemsApi.add(form);
    }
    setForm({ name: '', kategorie_id: '', notiz: '', menge: '', einheit: '' });
    setShowForm(false);
    load();
  };

  const handleAddKat = async (e) => {
    e.preventDefault();
    await kategorienApi.add(katForm);
    setKatForm({ name: '', icon: '📦' });
    setShowKatForm(false);
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Item löschen?')) return;
    await itemsApi.delete(id);
    load();
  };

  const handleEdit = (item) => {
    setEditItem(item);
    setForm({ name: item.name, kategorie_id: item.kategorie_id || '', notiz: item.notiz || '', menge: item.menge || '', einheit: item.einheit || '' });
    setShowForm(true);
  };

  const gefilterteItems = filterKat === 'alle' ? items : items.filter(i => i.kategorie_id === filterKat);

  // Gruppieren
  const gruppen = {};
  for (const item of gefilterteItems) {
    const key = item.kategorie_name || 'Sonstiges';
    const icon = item.kategorie_icon || '📦';
    if (!gruppen[key]) gruppen[key] = { icon, items: [] };
    gruppen[key].items.push(item);
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', padding: 16 }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
          <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#0ea5e9', cursor: 'pointer', fontSize: 14 }}>← Zurück</button>
          <div style={{ flex: 1 }}>
            <h1 style={{ color: '#f1f5f9', fontSize: 18, fontWeight: 700 }}>📋 Master-Liste</h1>
            <p style={{ color: '#64748b', fontSize: 12 }}>{items.length} Items · {kategorien.length} Kategorien</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => setShowKatForm(!showKatForm)} style={headerBtn}>🏷️ Kategorie</button>
            <button onClick={() => { setEditItem(null); setForm({ name: '', kategorie_id: '', notiz: '' }); setShowForm(!showForm); }}
              style={{ ...headerBtn, background: '#0ea5e9', color: 'white' }}>
              {showForm ? '✕' : '+ Item'}
            </button>
          </div>
        </div>

        {/* Kategorie Form */}
        {showKatForm && (
          <form onSubmit={handleAddKat} style={{ background: '#1e293b', borderRadius: 12, padding: 14, marginBottom: 14 }}>
            <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', marginBottom: 10 }}>🏷️ Neue Kategorie</h3>
            <div style={{ display: 'flex', gap: 8 }}>
              <input value={katForm.icon} onChange={e => setKatForm(p => ({ ...p, icon: e.target.value }))}
                placeholder="🏷️" style={{ ...inputStyle, width: 60 }} />
              <input value={katForm.name} onChange={e => setKatForm(p => ({ ...p, name: e.target.value }))}
                placeholder="Kategorie Name *" required style={{ ...inputStyle, flex: 1 }} />
              <button type="submit" style={{ background: '#0ea5e9', color: 'white', border: 'none', padding: '0 16px', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
                ✅
              </button>
            </div>
          </form>
        )}

        {/* Item Form */}
        {showForm && (
          <form onSubmit={handleAddItem} style={{ background: '#1e293b', borderRadius: 12, padding: 14, marginBottom: 14 }}>
            <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', marginBottom: 10 }}>
              {editItem ? '✏️ Item bearbeiten' : '➕ Neues Item'}
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
                placeholder="Item Name *" required style={inputStyle} />
              <select value={form.kategorie_id} onChange={e => setForm(p => ({ ...p, kategorie_id: e.target.value }))} style={inputStyle}>
                <option value="">– Kategorie wählen –</option>
                {kategorien.map(k => <option key={k.id} value={k.id}>{k.icon} {k.name}</option>)}
              </select>
              <input value={form.notiz} onChange={e => setForm(p => ({ ...p, notiz: e.target.value }))}
                placeholder="Notiz (optional)" style={inputStyle} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                <input value={form.menge} onChange={e => setForm(p => ({ ...p, menge: e.target.value }))}
                  placeholder="Menge (z.B. 3, 500)" style={inputStyle} />
                <input value={form.einheit} onChange={e => setForm(p => ({ ...p, einheit: e.target.value }))}
                  placeholder="Einheit (z.B. Stück, €, ml)" style={inputStyle} />
              </div>
              <button type="submit" style={{ background: '#0ea5e9', color: 'white', border: 'none', padding: '10px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
                {editItem ? '💾 Speichern' : '➕ Hinzufügen'}
              </button>
            </div>
          </form>
        )}

        {/* Filter */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 14, flexWrap: 'wrap' }}>
          <button onClick={() => setFilterKat('alle')} style={filterBtn(filterKat === 'alle')}>Alle ({items.length})</button>
          {kategorien.map(k => (
            <button key={k.id} onClick={() => setFilterKat(k.id)} style={filterBtn(filterKat === k.id)}>
              {k.icon} {k.name} ({items.filter(i => i.kategorie_id === k.id).length})
            </button>
          ))}
        </div>

        {/* Items gruppiert */}
        {Object.entries(gruppen).map(([kat, data]) => (
          <div key={kat} style={{ marginBottom: 16 }}>
            <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 8 }}>
              {data.icon} {kat} ({data.items.length})
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {data.items.map(item => (
                <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#1e293b', borderRadius: 10, padding: '10px 14px' }}>
                  <span style={{ flex: 1, color: '#f1f5f9', fontSize: 14 }}>
                    {item.name}
                    {item.menge && <span style={{ color: '#0ea5e9', fontSize: 12, marginLeft: 8, fontWeight: 600 }}>{item.menge}{item.einheit ? ' ' + item.einheit : ''}</span>}
                    {item.notiz && <span style={{ color: '#64748b', fontSize: 12, marginLeft: 8 }}>({item.notiz})</span>}
                  </span>
                  <button onClick={() => handleEdit(item)} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', fontSize: 16 }}>✏️</button>
                  <button onClick={() => handleDelete(item.id)} style={{ background: 'none', border: 'none', color: '#475569', cursor: 'pointer', fontSize: 16 }}>🗑️</button>
                </div>
              ))}
            </div>
          </div>
        ))}

        {gefilterteItems.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📋</div>
            <p>Noch keine Items</p>
          </div>
        )}
      </div>
    </div>
  );
}
const inputStyle = { background: '#0f172a', border: '1px solid #334155', color: '#f1f5f9', padding: '10px 12px', borderRadius: 8, fontSize: 14, outline: 'none', width: '100%' };
const headerBtn = { background: '#1e293b', color: '#94a3b8', border: '1px solid #334155', padding: '8px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 };
const filterBtn = (active) => ({ background: active ? '#0ea5e922' : '#1e293b', color: active ? '#0ea5e9' : '#64748b', border: active ? '1px solid #0ea5e944' : '1px solid #334155', padding: '4px 10px', borderRadius: 16, cursor: 'pointer', fontSize: 12 });
